// extracted by mini-css-extract-plugin
export var footer = "_o3-0";
export var inherit = "_o3-1";
export var input = "_o3-2";
export var modalContent = "_o3-3";
export var quillEditor = "_o3-4";
export var subtitle = "_o3-5";